module.exports = __webpack_public_path__ + "static/media/samwell.51505b38.jpg";